"use strict";

exports.__esModule = true;
exports.default = maybePromisify;
function maybePromisify(hook, syncLength) {
  if (hook.length <= syncLength) {
    return hook;
  }

  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var hasSyncResult = false;
    var syncResult = void 0;

    var resolvePromise = void 0;

    hook.apply(undefined, args.concat([function (result) {
      if (resolvePromise) {
        resolvePromise(result);
        return;
      }

      hasSyncResult = true;
      syncResult = result;
    }]));

    if (!hasSyncResult) {
      return new Promise(function (resolve) {
        resolvePromise = resolve;
      });
    }

    return syncResult;
  };
}
module.exports = exports["default"];